module.exports = __webpack_public_path__ + "img/book.e8c10df7.jpg";